const padSequence = (value: number, width = 6): string =>
  String(value).padStart(width, '0');

/** Normalise PES-260131-1549-68 (aucun espace autour des tirets). */
const normalizePeseeRootCode = (code: string): string =>
  code.trim().replace(/\s*-\s*/g, '-');

/**
 * Ancien code PES-AAMMJJ-HHMM-X + uniquement la séquence globale G.
 * Ex. PES-260131-1549-68-4
 * A / M / J ne sont jamais injectés dans ce code.
 */
export const formatPeseeCodeWithGlobalSequence = (
  code: string,
  sequenceGenerale?: number | null
): string => {
  if (!code) return '';
  const cleaned = normalizePeseeRootCode(code);
  const parts = cleaned.split('-').filter(Boolean);
  // Déjà au format racine + séquence
  if (parts.length >= 5) {
    return parts.join('-');
  }
  if (sequenceGenerale == null) return cleaned;
  return `${cleaned}-${Number(sequenceGenerale)}`;
};

export const getSequenceGeneraleFromPesee = (pesee: any): number | null => {
  if (!pesee || typeof pesee !== 'object') return null;
  const src = pesee.sequence_generale != null || pesee.sequenceGenerale != null
    ? pesee
    : pesee.data || pesee;
  const value = src.sequence_generale ?? src.sequenceGenerale;
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/** Code affiché : racine + tiret + séquence globale. */
export const getDisplayPeseeCode = (pesee: any): string => {
  if (!pesee) return '';
  const src =
    pesee.reference || pesee.référence || pesee.code
      ? pesee
      : pesee.data || pesee;
  const raw =
    src.reference || src.référence || src.code || (src.id != null ? `#${src.id}` : '');
  return formatPeseeCodeWithGlobalSequence(raw, getSequenceGeneraleFromPesee(src));
};

/** Séquences annuelle / mensuelle / journalière, affichage discret à droite. */
export const formatSecondarySequences = (
  annuelle?: number | null,
  mensuelle?: number | null,
  journaliere?: number | null
): string => {
  const parts: string[] = [];
  if (annuelle != null) parts.push(`A-${padSequence(annuelle, 5)}`);
  if (mensuelle != null) parts.push(`M-${padSequence(mensuelle, 4)}`);
  if (journaliere != null) parts.push(`J-${padSequence(journaliere, 4)}`);
  return parts.join(' · ');
};
